/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * saved: applied directly (contact email, or any edit of a pending Hub); submittedForReview: content changes of an approved Hub wait for review; withdrawn: the content sent matches the published one, so the pending changes were withdrawn; resubmitted: a declined Hub went back to review
 */
export enum UpdateHubResponseAllOfOutcome {
  saved = 'saved',
  submittedForReview = 'submittedForReview',
  withdrawn = 'withdrawn',
  resubmitted = 'resubmitted'
}
